import { request2 } from "./request";

const EApi = {
  loadEvents: () => request2("/main/line"),
  loadEvent: (id) => request2(`/main/event?id=${id}`),
  openOrder: (amount, bets) => request2(`/esport/open-order`, "post", { amount, bets }),
  orderStatus: (orderId) => request2(`/esport/order-status`, "post", { orderId }),
  ordersHistory: (dateFrom = null, dateTo = null) => request2(`/esport/orders-history`, "post", { dateFrom, dateTo }),
  couponHistory: (dateFrom = null, dateTo = null) => request2(`/esport/cupons-history`, "post", { dateFrom, dateTo }),
  loadSpotlights: () => request2("/main/spotlight")
};

window.EApi = EApi;

export default EApi;



// WEBPACK FOOTER //
// ./app/api/esports.js